export enum LinkageService {
  Nothing = 0, // 匿名ユーザー
  Social = 1, // Apple/Google 現在は未実装、定義のみ
  RUNNET = 2,
  OneASICS = 3,
}

export enum SelectableRequiredServices {
  Social,
  RUNNET,
  OneASICS,
  SocialOrRUNNET,
  SocialOrOneASICS,
}

export function getRequiredServices(requiredServices: SelectableRequiredServices): LinkageService[] {
  const result: LinkageService[] = [];
  switch (requiredServices) {
    case SelectableRequiredServices.Social:
      result.push(LinkageService.Social);
      break;
    case SelectableRequiredServices.RUNNET:
      result.push(LinkageService.RUNNET);
      break;
    case SelectableRequiredServices.OneASICS:
      result.push(LinkageService.OneASICS);
      break;
    case SelectableRequiredServices.SocialOrRUNNET:
      result.push(LinkageService.Social);
      result.push(LinkageService.RUNNET);
      break;
    case SelectableRequiredServices.SocialOrOneASICS:
      result.push(LinkageService.Social);
      result.push(LinkageService.OneASICS);
      break;
  }
  return result;
}

export function getSelectableRequiredServices(requiredServices: LinkageService[]): SelectableRequiredServices {
  if (requiredServices.length === 1) {
    switch (requiredServices[0]) {
      case LinkageService.Social:
        return SelectableRequiredServices.Social;
      case LinkageService.RUNNET:
        return SelectableRequiredServices.RUNNET;
      case LinkageService.OneASICS:
        return SelectableRequiredServices.OneASICS;
    }
  } else if (requiredServices.length === 2) {
    if (requiredServices.find(requiredService => requiredService === LinkageService.Social) && requiredServices.find(requiredService => requiredService === LinkageService.RUNNET)) {
      return SelectableRequiredServices.SocialOrRUNNET;
    }
    if (requiredServices.find(requiredService => requiredService === LinkageService.Social) && requiredServices.find(requiredService => requiredService === LinkageService.OneASICS)) {
      return SelectableRequiredServices.SocialOrOneASICS;
    }
  }
  throw new Error('Unexpected error!');
}
